export default "__VITE_ASSET__IoJ7ZP6b__"